import React, {Component, useState} from 'react'
import {Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import StdTable from '../StdTable'
import StdForm from '../StdForm'

import { reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
class ActionFormModal  extends Component{
  constructor(props) {
	  super(props);
	  this.state = {modal: false} 
  }

  render(){
	  const {submitAction, fields, action_text, form_name, initialValues, validation, buttonProps, trans_prefix, reset_button} = this.props
	  
	  const toggle = () => this.setState({ modal: !modal });
	  const {modal} = this.state
	  const Form = StdForm({form_name: form_name, validation: validation})
	  return  <React.Fragment>
	    {buttonProps != null && buttonProps.className != null ? <button  {...buttonProps} onClick={toggle}>{action_text}</button>  : <Button  {...buttonProps} onClick={toggle}>{action_text}</Button> }
	    <Form fields={fields} reset_button={reset_button} toggle={toggle} modal={modal} trans_prefix={trans_prefix} submitAction = {params => submitAction({values: params, props: this.props, successAction: toggle}) } initialValues={initialValues}  />
	  </React.Fragment>
  }
}




export default ActionFormModal
